import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * O tema do DS (tailwind.config.ts) tem nomes próprios de fonte, sombra e degradê: sem declará-los, o twMerge lê
 * `text-body` como cor e apaga `text-on-green`, e `shadow-card` não substitui `shadow-none`.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: ["display", "large-title", "title-2", "title-3", "body", "subhead", "footnote", "caption", "group-label"] }],
      shadow: [{ shadow: ["card", "float", "overlay", "green", "thumb"] }],
      "bg-image": [{ bg: ["green-gradient", "bonus-gradient", "bonus-surface"] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const CONTAGEM = new Intl.NumberFormat('pt-BR');
const REAIS_INTEIROS = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });

/** Quantidade em pt-BR ("3.046"). */
export const formatCount = (value: number) => CONTAGEM.format(value);

/** Reais inteiros, sem centavos ("R$ 574.382"): prêmio em vigor e valores de rede. */
export const reais = (value: number) => REAIS_INTEIROS.format(value);

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
}
